import { render, staticRenderFns } from "./DeviceControl.vue?vue&type=template&id=270c1ed0&scoped=true"
import script from "./DeviceControl.vue?vue&type=script&lang=js"
export * from "./DeviceControl.vue?vue&type=script&lang=js"
import style0 from "./DeviceControl.vue?vue&type=style&index=0&id=270c1ed0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270c1ed0",
  null
  
)

export default component.exports